<template >
    <div >
        <b-link to="/cart"
            class="count"

        >
            <i class="fa fa-shopping-cart" aria-hidden="true"></i>

            <p>{{ cnt }}</p>
        </b-link>
    </div>
</template>

<script>


export default{
    props:['cnt']
    

}

</script>

<style scoped>

.count{
    position: fixed;
    bottom: 40px;
    right: 24px;
    cursor: pointer;

}

.count p{
    position: fixed;
    bottom: 30px;
    right: 28px;
    font-size: 40px;
    font-weight: bold;
    color: red;
    text-shadow: 0 0 5px black;
}
.fa{
    font-size: 40px;
    color: #fff;
    text-shadow: 0 0 20px #286294;
}




</style>